import { render, staticRenderFns } from "./Spin.vue?vue&type=template&id=22977114&scoped=true"
import script from "./Spin.vue?vue&type=script&lang=js"
export * from "./Spin.vue?vue&type=script&lang=js"
import style0 from "./Spin.vue?vue&type=style&index=0&id=22977114&prod&lang=less&scoped=true"
import style1 from "./Spin.vue?vue&type=style&index=1&id=22977114&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22977114",
  null
  
)

export default component.exports